import React from 'react';
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../images/about/Our-Impact.webp"

function Impact(props) {
    return (
        <div className="tekrevol_dark_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="text-center m-auto order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1 my-auto order-1 order-md-2">
                        <div className="example" data-text="">
                            <h2>Our Impact</h2>
                        </div>
                        <div>
                            <p>Impact 2023 &amp; Beyond!</p>
                            <p>TekRevol vows to continue serving the community with social welfare and CSR efforts for communal betterment and well-being.Our vision to impact 20 million lives through better employment and education opportunities and empowerment marches toward 2023, and we will aggressively pursue the future beyond.</p>
                        </div>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Impact;